import { Controller } from "@hotwired/stimulus"
import flatpickr      from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import { english }    from "flatpickr/dist/l10n/default.js"
import { Spanish }    from "flatpickr/dist/l10n/es.js"

// Calendar — calendário INLINE (sempre visível) sobre Flatpickr.
//
// Diferente do date_picker (popup), aqui passamos `inline: true` e o calendário
// é renderizado direto na página. O valor selecionado é gravado, em ISO, no
// input escondido (data-calendar-target="input") que é enviado no form.
//
// Locale auto-detectado por <html lang>. Modos: single (default), range, multiple.
const LOCALES = {
  "pt-BR": Portuguese,
  "pt":    Portuguese,
  "en":    english,
  "es":    Spanish
}

export default class extends Controller {
  static targets = ["input"]
  static values = {
    mode:    { type: String, default: "single" },
    minDate: { type: String, default: "" },
    maxDate: { type: String, default: "" },
    months:  { type: Number, default: 1 }
  }

  connect() {
    const lang   = document.documentElement.lang || "pt-BR"
    const locale = LOCALES[lang] || Portuguese

    this.fp = flatpickr(this.inputTarget, {
      locale,
      inline:            true,
      mode:              this.modeValue,
      dateFormat:        "Y-m-d",
      minDate:           this.minDateValue || null,
      maxDate:           this.maxDateValue || null,
      showMonths:        Math.max(1, this.monthsValue),
      monthSelectorType: "static"
    })
  }

  disconnect() {
    this.fp?.destroy()
  }
}
